var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorInstitution(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_147_209",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_147_209",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACLUlEQVR4nO3bMWsUQRyG8Xd2jxTJWaU3dhY5SJNYiRBNEP0aJmBlET9FwJDSQj+FjSDKQbDbRkgW7PQDJOUZCJ5jmyozcW/uPe+eX717++eeG273hpMAAAAAAACwKMKtzxg2A/XCnmLckXRP0srEp5qskaSfCuGzfsf32t46cw90XX6Atl3S+eWxQnwpqSo3UlFjSW+1uvxa6+tX7mGk3ABtu6SL0UcpPC48z7R80ery81mIkPdJPr88nqM3X5Ke6OLXG/cQUs4KGDYD1fomqS4/zlSNVcUNPXzQOodIr4Aq7mv+3nxJqvUnvHAPkQ4Qqp0pzOERtOseIeM7IN4tP4ZJ1Jp7hJwv4X7xKXzuuAf4X+/n5wYBzAhgRgAzApgRwIwAZunfgk6a2OkKj7Zuvkbq9bueX95IQT8U9Unj8E7bm99vczIroLsVRQ0kHaiOpzppjjQc9nJPJsBk9SQdqOp/yI1AgBKCnqnuH+YcSoByXulrcz91EAHK6SnG/dRBBCgqPE0dQYCSMvYbyj8HzLrUc0ZKx+cYVoAZAcwIYEYAMwKYEcCMAGbZP5v+s1nfD+h6/Y5YAWYEMCOAGQHMCGBGADMCmJV/Dih9n95V4fv8FFaAGQHMCGBGADMCmBHAjABm7AewH7DYCGBGADMCmBHAjABmBDBjP4D9gMVGADMCmBHAjABmBDAjgFn554BZZ/4fNCvAjABmBDAjgBkBzAhgRgAAAAAAAABgSv4COSJx8x7j8PUAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorInstitution);
export default __webpack_public_path__ + "static/media/colorInstitution.8b1da5f3088140be102bd9a1c4e19cac.svg";
export { ForwardRef as ReactComponent };